var _path, _circle, _circle2, _circle3, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBranchIcon = function SvgBranchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 6,
    r: 2.5,
    stroke: "#2D8825"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 6,
    r: 2.5,
    stroke: "#2D8825"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 18,
    r: 2.5,
    stroke: "#2D8825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2D8825",
    d: "M8 8v8M7.5 12.5H14a2 2 0 0 0 2-2v-2"
  })));
};
export { SvgBranchIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIvPgogICAgPGNpcmNsZSBjeD0iOCIgY3k9IjYiIHI9IjIuNSIgc3Ryb2tlPSIjMkQ4ODI1Ii8+CiAgICA8Y2lyY2xlIGN4PSIxNiIgY3k9IjYiIHI9IjIuNSIgc3Ryb2tlPSIjMkQ4ODI1Ii8+CiAgICA8Y2lyY2xlIGN4PSI4IiBjeT0iMTgiIHI9IjIuNSIgc3Ryb2tlPSIjMkQ4ODI1Ii8+CiAgICA8bGluZSB4MT0iOCIgeTE9IjgiIHgyPSI4IiB5Mj0iMTYiIHN0cm9rZT0iIzJEODgyNSIvPgogICAgPHBhdGggZD0iTTcuNSAxMi41SDE0QzE1LjEwNDYgMTIuNSAxNiAxMS42MDQ2IDE2IDEwLjVWOS42NjY2N1Y4LjUiIHN0cm9rZT0iIzJEODgyNSIvPgo8L3N2Zz4=";